import { message } from 'ant-design-vue'
import axios from 'axios'
import router from '@/router'

const OK = 2000
const errorCodeArr = ['403', '404', '500']

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true,
  timeout: 60000
  // timeout: 2 * 60 * 1000
})

service.interceptors.request.use(
  config => {
    // config.headers['access-token'] = localStorage.getItem('token')
    // console.log('config', config)
    config.headers.pid = '239'
    config.headers.lang = 'zh'
    config.headers.cid = localStorage.getItem('customerCode')
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  async res => {
    if (res.config.responseType === "blob") {
      return res.data
    }
    const { data: { code, msg, status }, config } = res
    let errorMessage = res.data.message || ''
    let statuscode = ''
    if (code) {
      statuscode = code
    } else {
      statuscode = status // 兼容登陆接口
    }
    if (statuscode === 20000 || statuscode === 0) { // 成功
      return res.data.data
    } else {
      if (errorMessage) {
        message.error(errorMessage)
      } else {
        message.warning(msg)
      }
      const notlogincodes = [3, 30000, 30001, 30002]
      if (notlogincodes.includes(statuscode)) {
        localStorage.removeItem('customerCode')
        router.push('/login')
      }
      return Promise.reject(res.data.message)
    }
  },
  async error => {
    console.log(error.message);
    if (error.message.includes('401')) {
      localStorage.removeItem('customerCode')
      router.push('/login')
    } else {
      message.warning('network error')
    }
    return Promise.reject(error)
  }
)

export default service
